// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CategoryContent_wrapper__BSlzv","panel":"CategoryContent_panel__5rjMg"};